export default __webpack_public_path__ + "arrow-pointing-right-in-a-circle.png";